export const isNumeric = (num) => {
  return !isNaN(num) && !isNaN(parseFloat(num));
};

export const toFixed = (num, fractionDigits = 0) => {
  num = Number(num);
  if (num == 0) return num.toFixed(fractionDigits);
  const fixedNum = num.toFixed(fractionDigits);
  if (fixedNum == 0) return toFixed(num, fractionDigits + 1);
  return fixedNum;
};

export const hexToRgb = (hex) => {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const formatAddress = (address, fractionDigits = 3) => {
  try {
    return address.slice(0, fractionDigits) + "..." + address.slice(-fractionDigits);
  } catch (error) {
    return undefined;
  }
};

export const numberWithCommas = (x) => {
  const [naturalPart, decimalPart] = x.toString().split(".");
  let out = naturalPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (decimalPart) out += "." + decimalPart;
  return out;
};

export const compactNumber = (value, fractionDigits = 1) => {
  const suffixes = ["", "K", "M", "B", "T"];
  const suffixNum = Math.floor((("" + parseInt(value)).length - 1) / 3);
  let shortValue = parseFloat((value / Math.pow(1000, suffixNum)).toPrecision(fractionDigits + 1));
  if (shortValue % 1 !== 0) shortValue = toFixed(shortValue, fractionDigits);
  return shortValue + suffixes[suffixNum];
};

export const random = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const getNonce = () => {
  const len1 = random(2, 10);
  let _to = 3;
  Array(len1)
    .fill(0)
    .forEach((_) => {
      return (_to = _to * random(2, 10));
    });
  return random(2, _to);
};

export const isObject = (item) => {
  return item && typeof item === "object" && !Array.isArray(item) && item != null;
};

export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }
  return mergeDeep(target, ...sources);
}
